import {
  applyLearnedCorrections
} from './ocrLearning';
function normalizeSurveyNumbers(text: string): string {

  return text.replace(/\b\d+\b/g, (token) => {

    // Already contains decimal
    if (token.includes('.'))
      return token;

    // 1630 -> 1.630
    if (/^[1-5]\d{3}$/.test(token))
      return token[0] + "." + token.slice(1);

    // 92390 -> 2.390
    if (/^\d{5}$/.test(token)) {

      const last4 = token.slice(-4);

      if (/^[1-5]\d{3}$/.test(last4))
        return last4[0] + "." + last4.slice(1);

    }

    // 12049 -> 2.049
    if (/^\d{5,6}$/.test(token)) {

      const end = token.slice(-3);

      if (/^\d{3}$/.test(end))
        return "2." + end;

    }

    return token;

  });

}
export function normalizeOCRText(text: string): string {

  text =
    applyLearnedCorrections(text);
text =
  normalizeSurveyNumbers(text);
  return text
    .toUpperCase()

    // decimal cleanup
    .replace(/,/g, '.')

    // BS
    .replace(/\b8S\b/g, 'BS')
    .replace(/\bB5\b/g, 'BS')
    .replace(/\b85\b/g, 'BS')
    .replace(/\bB S\b/g, 'BS')

    // IS
    .replace(/\b1S\b/g, 'IS')
    .replace(/\bLS\b/g, 'IS')
    .replace(/\bI5\b/g, 'IS')
    .replace(/\bI S\b/g, 'IS')

    // FS
    .replace(/\bF5\b/g, 'FS')
    .replace(/\bF S\b/g, 'FS')

    // TBM
    .replace(/\bT8M\b/g, 'TBM')
    .replace(/\bT BM\b/g, 'TBM')
    .replace(/\bB\.?M\.?\b/g, 'TBM')
    .replace(/BENCH\s*MARK/g, 'TBM')

    // CP
    .replace(/\bC\.?P\.?\b/g, 'CP')
    .replace(/CHANGE\s*POINT/g, 'CP')
    .replace(/TURNING\s*POINT/g, 'CP')

    // OCR number mistakes
    .replace(/[|]/g, '1')
  
    // spaces
    .replace(/\bB85\b/g,'BS')
    .replace(/\b8S\b/g,'BS')
    .replace(/\bI6\b/g,'IS')
    .replace(/\b1S\b/g,'IS')
    .replace(/\bFS\b/g,'FS')

    .replace(/[ \t]+/g, ' ')
    .trim();
}
